import { render } from "./ContentPage.vue?vue&type=template&id=0661331d&ts=true"
import script from "./ContentPage.vue?vue&type=script&lang=ts"
export * from "./ContentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.9.3__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__